.mapboxgl-ctrl-bottom-left {
    display: flex;
    gap: 8px;
}

.google-maps-data-source-container {
    /* Ensure text is aligned with the Google logo */
    margin-top: 2px !important;
    font-size: 14px;
    /* Creates a text outline */
    -webkit-text-stroke: 3px black;
    color: white;
    paint-order: stroke fill;
}

.google-maps-data-sources {
    display: flex;
    gap: 3px;
}

.interpunct {
    font-size: 25px;
}